import React from 'react';
import { HotYoterStateBanner } from './HotYoterStateBanner';

export const HotYoterStateSection = ({
    pageTitle,
    content,
    purchasedBenefits = [],
    testID = 'hot-yoter-state-section',
}) => {
    const hasPurchasedBenefits = purchasedBenefits.length > 0;
    const hasStateText = Boolean(content?.title || content?.subtitle);

    if (!pageTitle && !hasStateText && !hasPurchasedBenefits) {
        return null;
    }

    return (
        <section className="hot-yoter-state-section" testId={testID} dir="rtl">
            <HotYoterStateBanner
                pageTitle={pageTitle}
                content={content}
                purchasedBenefits={purchasedBenefits}
                testID={`${testID}-banner`}
            />
        </section>
    );
};
